import { Dialog } from './dialogs/core';
import { ErrorDialog } from './dialogs/error';
import { WarningDialog } from './dialogs/warning';
import { ConfirmationDialog } from './dialogs/confirmation';
import useDialog from './hooks/use-dialog';
import useErrorDialog from './hooks/use-error-dialog';
import useWarningDialog from './hooks/use-warning-dialog';
import useConfirmationDialog from './hooks/use-confirmation-dialog';
import { DialogProvider, DialogContext } from './context/provider';
import { DialogTarget } from './target';
import { StickyFooter } from './sticky-footer';
export { Dialog, WarningDialog, ErrorDialog, ConfirmationDialog, useDialog, useWarningDialog, useErrorDialog, useConfirmationDialog, DialogProvider, DialogContext, DialogTarget, StickyFooter };